import { useEffect } from "react";
import { download_updated_excel } from "../apis/services/csaApi";
import en from "../json/en.json";
import ch from "../json/ch.json";
import { useAssessment } from '../components/assessmentContext';
export default function AssessmentReport() {
      const { activeAssessment } = useAssessment();
    const lId =
        localStorage.getItem("languageId") || "1";

          useEffect(() => {
            console.log("activeAssessment",activeAssessment);
            console.log('localStorage.getItem("AssessmentId")',localStorage.getItem("AssessmentId"));
            
          }, [localStorage.getItem("AssessmentId"),activeAssessment]);

    const handleExport = async () => {
        try {
            const response = await download_updated_excel(localStorage.getItem("userName"), localStorage.getItem("AssessmentId"));
            // console.log("xl data", response);
            if (!response) {
                throw new Error('No response received');
            }
            // const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(response);

            const a = document.createElement('a');
            a.href = downloadUrl;
            const ass_txt = localStorage.getItem("AssessmentText");
            a.download = ass_txt+""+' Report.xlsx';
            document.body.appendChild(a);
            a.click();

            // Clean up
            window.URL.revokeObjectURL(downloadUrl);
            document.body.removeChild(a);

            // setData(response || []);
        } catch (error) {
            console.error("Error fetching data:", error);
            // setData([]);
        }
    };

    return (
        <div className="wrapper">
            <div className="section-questions-result">
                <div className="w-full flex justify-end gap-4">
                    <button
                        onClick={handleExport}
                        className="bg-[#f40009] text-white text-2xl px-4 py-2 rounded-md hover:bg-[#d90008] transition-colors"
                    >
                        {localStorage.getItem("AssessmentText")} {lId === "1" ? en.report : ch.report}
                    </button>
                </div>
            </div>
        </div>
    );
}